export default __webpack_public_path__ + "static/media/background_molecule_3.cd9b1452.jpg";